export const AwardsController = {
    index(): void {},
};
